import type { NetGame } from '@orb/net';
import type { TotemKind } from '@orb/sim';
import { firstLetter } from '../ui/kit';
import { SHORT } from './TotemRack';

/**
 * The ally in the corner (HUD v2, co-op): their medallion and nick, their totem, and whether they are
 * in the game, losing the connection, or gone (their field fights on either way). Online the
 * room's messages say it; with the bot, it is always there.
 */
export function mountAllyChip(host: HTMLElement, o: { net: NetGame | null; name: () => string | null; totem: () => TotemKind | null }) {
  const chip = document.createElement('div');
  chip.className = 'ally-chip';
  chip.setAttribute('role', 'status');
  chip.innerHTML = '<span class="ally-medal" aria-hidden="true"><b></b></span><span class="ally-who"><b class="ally-name"></b><span class="ally-line"></span></span>';
  const letter = chip.querySelector('.ally-medal b')!, name = chip.querySelector('.ally-name')!, line = chip.querySelector('.ally-line')!;
  host.append(chip);
  let state: 'in' | 'away' | 'gone' = 'in';
  const net = o.net;
  if (net) {
    const prev = net.onMessage;
    net.onMessage = (m) => {
      prev(m);
      if (m.type === 'player_joined' && m.player.seat !== net.seat) state = 'in';
      if (m.type === 'player_left' && m.seat !== net.seat) state = m.reason === 'disconnected' ? 'away' : 'gone';
      update();
    };
  }
  let last = '';
  const update = () => {
    const nick = o.name(), totem = o.totem();
    const where = state === 'away' ? 'втрачає зв’язок' : state === 'gone' ? 'вийшов · поле воює' : null;
    const text = [totem ? `тотем ${SHORT[totem]}` : null, where].filter(Boolean).join(' · ');
    const key = `${nick}|${text}|${state}`;
    if (key === last) return;
    last = key;
    letter.textContent = firstLetter(nick || 'С');
    name.textContent = nick || 'Союзник';
    line.textContent = text;
    chip.dataset.state = state;
    chip.hidden = !nick && !net?.room?.players.some((p) => p.seat !== net.seat);
  };
  update();
  // the totem changes by the ally's own hand: a light poll is enough (it stops with the chip)
  const timer = setInterval(() => { if (chip.isConnected) update(); else clearInterval(timer); }, 500);
  return chip;
}
